module.exports = __webpack_public_path__ + "static/andina.regular-9f39c17eb29e2c8061f95a0885c80a13.otf";